var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentTransactionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#66BB6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4667 12.8001C20.2 12.5334 19.8 12.5334 19.5333 12.8001L14.5333 17.8001L12.4667 15.7334C12.2 15.4668 11.8 15.4668 11.5333 15.7334C11.2667 16.0001 11.2667 16.4001 11.5333 16.6668L14.0667 19.2001C14.2 19.3334 14.3333 19.4001 14.5333 19.4001C14.7333 19.4001 14.8667 19.3334 15 19.2001L20.4667 13.7334C20.7333 13.4668 20.7333 13.0668 20.4667 12.8001Z",
    fill: "#F9F9FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentTransactionIcon);
export default __webpack_public_path__ + "static/media/recentTransactionIcon.61ddd06f6eec0b731f217a7ebbf3cfb8.svg";
export { ForwardRef as ReactComponent };